import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row text-start" }
const _hoisted_2 = { class: "product-item card col-md-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-10" }
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = { class: "bold mb-0" }
const _hoisted_8 = { class: "d-flex mt-1" }
const _hoisted_9 = { class: "pe-5 d-inline-block" }
const _hoisted_10 = { class: "pe-5 d-inline-block" }
const _hoisted_11 = { class: "bi bi-info-circle" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-2 d-flex align-items-start"
}
const _hoisted_13 = { class: "discount-box" }
const _hoisted_14 = { class: "text-end col-md-3" }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "d-flex flex-grow-1 justify-content-end" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_20 = { class: "d-flex flex-column align-items-start mb-3" }
const _hoisted_21 = ["title"]
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "row mb-3" }
const _hoisted_24 = { class: "col-md-10" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-2 small py-1 calc-date" }
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = {
  key: 0,
  class: "small red p-2"
}
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "bi bi-info-circle fs-4 d-inline-block float-end" }
const _hoisted_32 = ["min"]
const _hoisted_33 = {
  key: 0,
  class: "small red p-2"
}
const _hoisted_34 = {
  key: 1,
  class: "small red p-2"
}
const _hoisted_35 = { class: "col-md-2 text-end" }
const _hoisted_36 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VMenu = _resolveComponent("VMenu")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-md-2 d-none d-md-block" }, [
            _createElementVNode("i", { class: "bi bi-image dummy-productimage" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.discountSum > 0 ? 'col-md-7 ' : 'col-md-9 ')
              }, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.productData ? _ctx.getValue(_ctx.productData.customerProductName) : ""), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.productData
                      ? _ctx.getValue(_ctx.productData.customerProductNumber)
                      : "") + " " + _toDisplayString(_ctx.productData.name), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.productData
                        ? _ctx.getValue(_ctx.productData.productPackagingName)
                        : ""), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(" MOQ: " + _toDisplayString(_ctx.productData
                        ? _ctx.formatNumberWithSpaces(_ctx.getValue(_ctx.productData.moq))
                        : "") + " boxes ", 1),
                    _withDirectives(_createElementVNode("i", _hoisted_11, null, 512), [
                      [_directive_tooltip, _ctx.moqInfoBox]
                    ])
                  ])
                ])
              ], 2),
              (_ctx.discountSum > 0 && _ctx.totalDiscount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, "Discount: -" + _toDisplayString(_ctx.totalDiscount), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.totalPrice), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.currentPrice
                      ? _ctx.formatCurrency(
                          _ctx.getValue(_ctx.currentPrice),
                          _ctx.getValue(_ctx.productData.currency)
                        )
                      : _ctx.currentPriceInfo
                      ? _ctx.formatCurrency(
                          _ctx.getValue(_ctx.currentPriceInfo.price),
                          _ctx.getValue(_ctx.productData.currency)
                        )
                      : "") + " / box ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.productData ? _ctx.getValue(_ctx.productData.description) : ""), 1)
            ]),
            (
                _ctx.productData.artworks && _ctx.productData.artworks.some((a) => a.id)
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Artwork version", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productData.artworks, (artWork) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-2",
                      key: artWork.id
                    }, [
                      _createVNode(_component_VMenu, null, {
                        popper: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getArtworkConfig(artWork.part)
                        ? _ctx.getArtworkConfig(artWork.part)?.tooltip
                        : "No tooltip available"), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", {
                              class: "input-group-text",
                              title: _ctx.getArtworkConfig(artWork.part)?.title
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.getArtworkConfig(artWork.part)?.icon),
                                title: _ctx.getArtworkConfig(artWork.part)?.title
                              }, null, 10, _hoisted_22)
                            ], 8, _hoisted_21),
                            _createElementVNode("span", null, _toDisplayString(artWork.supplierNumber ?? artWork.name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Comment", -1)),
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.artworkComment) = $event)),
                  rows: "1"
                }, null, 512), [
                  [_vModelText, _ctx.artworkComment]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[7] || (_cache[7] = _createTextVNode(" Calc delivery date on confirmed order")),
                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.calculatedDeliveryDate), 1)
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Requested Delivery", -1)),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  "min-date": _ctx.minDate,
                  format: _ctx.dateFormat,
                  class: "datepicker",
                  "auto-apply": true
                }, null, 8, ["modelValue", "min-date", "format"]),
                (_ctx.selectedDate === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Date is required "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [
                    [_directive_tooltip, {
                      content: _ctx.priceInfoBox,
                    }]
                  ]),
                  _cache[9] || (_cache[9] = _createTextVNode("   ")),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    id: "customQuantity",
                    ref: "quantityBox",
                    min: _ctx.productData.moq,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customQuantity) = $event)),
                    placeholder: "Enter quantity...",
                    onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.customQuantityChange()))
                  }, null, 40, _hoisted_32), [
                    [_vModelText, _ctx.customQuantity]
                  ]),
                  (_ctx.showNotInRange)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Quantity is not in quantity range "))
                    : _createCommentVNode("", true),
                  (
                      _ctx.customQuantity &&
                      _ctx.productData.moq &&
                      _ctx.productData.moq - 1 >= _ctx.customQuantity
                    )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Min. order quantity is " + _toDisplayString(_ctx.productData.moq), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(
                    _ctx.hasError(_ctx.productData) ? 'disabled-button-container' : ''
                  )
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(
                      'btn btn-primary w-100 ' +
                      (_ctx.hasError(_ctx.productData) ? 'disabled-button' : '')
                    ),
                    disabled: 
                      _ctx.hasError(_ctx.productData) ||
                      _ctx.showNotInRange ||
                      (_ctx.customQuantity &&
                      _ctx.customQuantity > 0 &&
                      _ctx.productData.moq &&
                      _ctx.selectedDate
                        ? _ctx.productData.moq - 1 >= _ctx.customQuantity
                        : true)
                    ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addToCart()))
                  }, " Add to order ", 10, _hoisted_36)
                ], 2)), [
                  [_directive_tooltip, {
                    content: _ctx.hasError(_ctx.productData)
                      ? 'Cannot add to cart: ' + _ctx.productData.errorMessage
                      : '',
                  }]
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}